import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { AddQuestionListItemFragmentDoc } from '../../fragments/generated/AddQuestionListItem';
import { UserFragmentDoc } from '../../../../../../../../../graphql/fragments/generated/User';
import { SkillPillFragmentDoc } from '../../../../../../../../events/graphql/fragments/generated/SkillPill';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type QuestionsQueryVariables = Types.Exact<{
  filters: Types.QuestionFilters;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type QuestionsQuery = { questions: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum, subType?: Types.QuestionSubTypeEnum | null, createdBy?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, skills: Array<{ id: string, name: string }> } }> | null } };


export const QuestionsDocument = /*#__PURE__*/ gql`
    query questions($filters: QuestionFilters!, $sort: [SortType!], $first: Float, $after: String) {
  questions(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...AddQuestionListItem
      }
    }
  }
}
    ${AddQuestionListItemFragmentDoc}
${UserFragmentDoc}
${SkillPillFragmentDoc}`;

export function useQuestionsQuery(options: Omit<Urql.UseQueryArgs<QuestionsQueryVariables>, 'query'>) {
  return Urql.useQuery<QuestionsQuery, QuestionsQueryVariables>({ query: QuestionsDocument, ...options });
};